import { FC, memo } from 'react'

import { Link } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { IconName, IconSize } from 'ui/components/Icon'

import { WarningsProps } from './Warnings.types'

import { s } from './styles'

export const Warnings: FC<WarningsProps> = memo(({ data, onResolve }) => {
  const { showDataMismatch, id, showWarnings, showFinCENWarnings } = data

  return (
    <>
      {showWarnings?.length > 0 && (
        <s.Box>
          <s.Title $weight={700}>
            <s.WarningIcon name={IconName.ERROR_RED} size={IconSize.M} /> Warning(s)
          </s.Title>
          <s.List>
            {showWarnings.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </s.List>
          <s.ResolveButton onClick={onResolve}>Mark all warnings as resolved</s.ResolveButton>
        </s.Box>
      )}

      {showDataMismatch && (
        <s.Box>
          <s.Title $weight={700}>
            <s.WarningIcon name={IconName.ERROR_RED} size={IconSize.M} /> Data Mismatch Detected
          </s.Title>
          <s.Text>There is a mismatch between Orbit and SAR data.</s.Text>
          <Link to={routes.bank.bsa.sar.changes} params={{ id: id.toString() }} target="_blank">
            <s.ResolveButton>View Details</s.ResolveButton>
          </Link>
        </s.Box>
      )}

      {showFinCENWarnings?.length > 0 && (
        <s.Box>
          <s.Title $weight={700}>
            <s.WarningIcon name={IconName.ERROR_RED} size={IconSize.M} /> FinCEN Warning(s)
          </s.Title>
          <br />
          <s.Title $weight={600}>All FinCEN warnings will be cleared once SAR is corrected and re-submitted.</s.Title>
          <s.List>
            {showFinCENWarnings.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </s.List>
        </s.Box>
      )}
    </>
  )
})
